export const STATUS_TRACKER_OPTIONS_ENUM = {
  CURRENT: 'current',
  COMPLETED: 'completed',
  NEXT: 'next',
  WARNING: 'warning',
  ERROR: 'error',
  ON_HOLD: 'on-hold'
}
export default STATUS_TRACKER_OPTIONS_ENUM
